import { Box, Divider, Icon, Text } from '@factorialco/deprecated-design-system'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

export interface FooterComponmentProps {
  currentIndex: number
  setCurrentIndex: (index: number) => void
  total: number
  actionButtonsComponent: React.ReactNode
}

export const CarouselFooter = ({
  setCurrentIndex,
  total,
  currentIndex,
  actionButtonsComponent,
}: FooterComponmentProps) => {
  const handlePrev = useUnsafeCallback(() => {
    if (currentIndex === 0) return
    const newIndex = currentIndex - 1
    setCurrentIndex(newIndex)
  }, [setCurrentIndex, currentIndex])

  const handleNext = useUnsafeCallback(() => {
    if (currentIndex === total - 1) return
    const newIndex = currentIndex + 1
    setCurrentIndex(newIndex)
  }, [currentIndex, setCurrentIndex, total])

  const canGoBack = currentIndex > 0
  const canGoForward = currentIndex < total - 1

  return (
    <>
      <Box width="full" paddingY="s16">
        <Divider />
      </Box>
      <Box width="full" flexDirection="row" justifyContent="spaceBetween">
        <Box flexDirection="row">
          <Box
            flexDirection="row"
            gap="s8"
            alignItems="center"
            minWidth="s80"
            justifyContent="spaceBetween"
          >
            <Box onClick={canGoBack ? handlePrev : undefined}>
              <Icon.Medium icon="chevron-left" color={canGoBack ? 'grey800' : 'grey100'} />
            </Box>
            {total > 1 && (
              <Text.Normal>
                {currentIndex + 1}/{total}
              </Text.Normal>
            )}

            <Box onClick={canGoForward ? handleNext : undefined}>
              <Icon.Medium icon="chevron-right" color={canGoForward ? 'grey800' : 'grey100'} />
            </Box>
          </Box>
        </Box>
        <Box flexDirection="row">{actionButtonsComponent}</Box>
      </Box>
    </>
  )
}
